// theme constant
export const gridSpacing = 3;
export const headerHeight = 64;
export const drawerWidthExpanded = 260;
export const drawerWidthCollapsed = 84;
